import React from 'react';
import { Flex, Text } from '@theme-ui/components';
import { colors,typography } from '../../styles/theme';

const AnnouncementBanner = ({ data }) => {
	return (
		<Flex sx={WRAPPER_STYLE}>
			<Text dangerouslySetInnerHTML={{ __html: data }} />
		</Flex>
	);
};

const WRAPPER_STYLE = {
  ...typography.h5,
  bg: colors.primary100,
  color: colors.primaryMain,
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  width: '100%',
  py:["1.06rem","1.06rem","1.44rem","1.44rem"],
  px:["1rem","1rem",0,0],
  'a': {
    color: colors.primaryMain,
  },
  p: {
    textAlign: 'center',
    margin: '0px !important',
    padding: '0px !important',
  },
  span: {
    textAlign: 'center',
    margin: '0px !important',
    padding: '0px !important',
  }
};

export default AnnouncementBanner;
